export function calculateReadingTime(content: string, perex?: string): number {
	const wordsPerMinute = 200;
	const fullText = `${perex ?? ""} ${content}`;
	const textWithoutHtml = fullText.replace(/<[^>]*>/gu, " ");
	const words = textWithoutHtml
		.replace(/\s+/gu, " ")
		.trim()
		.split(" ")
		.filter((word) => word.length > 0);
	const minutes = Math.ceil(words.length / wordsPerMinute);

	return Math.max(1, minutes);
}
